<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
    </div>
    <strong>Copyright &copy; {{ new Date().getFullYear() }} {{creatorName}} - <a href="#"> <img src="/static/img/logo-interna.png"></a></strong> - Todos os direitos reservados.
  </footer>
</template>

<script>
export default{
  data () {
    return {
      creatorName: null,
      projectName: null
    }
  },
  mounted () {
    this.creatorName = this.$config.creatorName
    this.projectName = this.$config.projectName
  }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?ee64760e